import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import {
	Customer, Address, PaymentTypes, ShipmentTypes, DisplayShoppingCart, OrderDTO,
	DocumentsToPrint, ErrorMessages, Printer, BookingOffice, AvailableShipmentTypeDTO
} from "../../../models"


@Component({
	selector: 'checkout-display-presentation',
	templateUrl: "./checkout-display.presentation.html",
	styles: [require("./checkout-display.presentation.scss")]
})
export class CheckoutDisplayPresentation {

	@Input() customer: Customer;
	@Input() billingAddress: Address
	@Input() shippingAddress: Address
	@Input() totalValue: number
	@Input() paymentType: string
	@Input() shipmentType: string
	@Input() set errorMessages(errorMessages: ErrorMessages) {
		this.shipmentErrorMessages = errorMessages.shipmentErrors
		this.paymentErrorMessages = errorMessages.paymentErrors
		this.ticketPrinterErrorMessages = errorMessages.ticketPrinterErrors
		this.disableButtonNext = Object.keys(errorMessages).map(key => errorMessages[key].length > 0).reduce((a, b) => a || b)
	}
	@Input() ticketPrinterId: string
	@Input() displayShoppingCart: DisplayShoppingCart
	@Input() ticketAddresses: Record<string, Address>
	@Input() documentsToPrint: DocumentsToPrint
	@Input() printerList: Printer[]
	@Input() bookingOffice: BookingOffice;
	@Input() availableShipmentTypesInfo: AvailableShipmentTypeDTO;
	@Input() availablePaymentTypes: string[];
	@Input() orderComment: string;

	@Output() selectCustomerClicked = new EventEmitter<void>();
	@Output() removeCustomerClicked = new EventEmitter<void>();
	@Output() editCustomerClicked = new EventEmitter<Customer>();
	@Output() selectShippingAddressClicked = new EventEmitter<Customer>();
	@Output() selectBillingAddressClicked = new EventEmitter<Customer>();
	@Output() paymentTypeChange = new EventEmitter<string>();
	@Output() shipmentTypeChange = new EventEmitter<string>();
	@Output() placeOrderClicked = new EventEmitter<OrderDTO>();
	@Output() documentsToPrintChange = new EventEmitter<DocumentsToPrint>();
	@Output() printerChanged = new EventEmitter<string>();
	@Output() returnToShoppingCart = new EventEmitter<void>();

	protected paymentTypesEnum = PaymentTypes
	protected shipmentTypesEnum = ShipmentTypes
	protected shipmentErrorMessages: string[] = []
	protected paymentErrorMessages: string[] = []
	protected ticketPrinterErrorMessages: string[] = []
	protected showTicketAddressFormsPopup: boolean = false;

	private disableButtonNext: boolean

	public constructor() {
	}

	private showTicketAddressForms(): void {
		this.showTicketAddressFormsPopup = true;
	}
	private hideTicketAddressForms(): void {
		this.showTicketAddressFormsPopup = false;
	}

	public placeOrder() {
		this.placeOrderClicked.emit({
			customerUUID: this.customer ? this.customer.uuid : null,
			shippingAddress: this.shippingAddress ? this.shippingAddress : null,
			billingAddress: this.billingAddress ? this.billingAddress : null,
			shoppingCartId: this.displayShoppingCart.secureId,
			paymentType: this.paymentType,
			shipmentType: this.shipmentType,
			shipmentFee: this.bookingOffice.shipmentFees[this.shipmentType] ? this.bookingOffice.shipmentFees[this.shipmentType].money : null,
			ticketAddresses: null,
			comment: this.orderComment
		});

	}

	documentsToPrintTicketChanged(ticketPrintValue: boolean) {
		this.documentsToPrintChange.emit(
			Object.assign({}, this.documentsToPrint, {ticketPrint: !ticketPrintValue})
		)
	}

	documentsToPrintInvoiceChanged(invoicePrintValue: boolean) {
		this.documentsToPrintChange.emit(
			Object.assign({}, this.documentsToPrint, {invoicePrint: invoicePrintValue})
		)
	}

	documentsToPrintPdfTicketChanged(pdfTicketsValue: boolean) {
		this.documentsToPrintChange.emit(
			Object.assign({}, this.documentsToPrint, {pdfTickets: pdfTicketsValue})
		)
	}

	documentsToPrintCoverLetterChanged(coverLetterPrintValue: boolean) {
		this.documentsToPrintChange.emit(
			Object.assign({}, this.documentsToPrint, {coverLetterPrint: coverLetterPrintValue})
		)
	}

	shipmentTypeChanged(shipmentType) {
		this.shipmentTypeChange.emit(shipmentType)
	}

}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout-display/checkout-display.presentation.ts